export default {
  getRoomName: '/infrastructureRoom/getRoomName',
  getRoomNames: '/infrastructureRoom/getRoomNames'
}
